var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19H24M32 17H38C39 17 40 18.2 40 19V25L32 35C32 35 25.9052 35 22 35M22 35C22 31.0948 22 25 22 25H15C12.5 25 10 28.5 10 31V35C10 35 12.4379 35 14 35M22 35C22 37.5 20 39 18 39C16 39 14 37.5 14 35M22 35C18.8758 35 17.1242 35 14 35M46 35C46 37.5 44 39 42 39C40 39 38 37.5 38 35C38 32.5 40 31 42 31C44 31 46 32.5 46 35Z",
    stroke: "#F32B2B",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.2f9ad5faf773bf155cba875bc5cf4011.svg";
export { ForwardRef as ReactComponent };